/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ChangeDetectorRef, ElementRef, Renderer2, NgZone, Input, Directive, Injectable } from '@angular/core';
import { ChangedEvent, MessageService, TextService } from '@typescript-kit/core';
import { ValueModel } from '@typescript-kit/view';

import { BaseDirective } from './base.directive';

@Directive({
  selector: '[kitValueError]'
})
export class ValueErrorDirective extends BaseDirective<ValueModel> {
  private originalDisplayStyle: string;

  constructor(
    changeDetector: ChangeDetectorRef,
    elementRef: ElementRef,
    renderer: Renderer2,
    ngZone: NgZone,
    textService: TextService,
    protected messageService: MessageService
  ) {
    super(changeDetector, elementRef, renderer, ngZone, textService);
    this.originalDisplayStyle = null;
  }

  get hostClass(): string {
    return 'kit-value-error';
  }

  @Input()
  set kitValueError(model: ValueModel) {
    this.model = model;
  }

  get kitValueError(): ValueModel {
    return this.model;
  }

  protected onModelChanged(model: ValueModel) {
    super.onModelChanged(model);
    this.refreshErrorDisplay();
  }

  protected onModelPropertyChanged(event: ChangedEvent): void {
    super.onModelPropertyChanged(event);
    const changes = event.changes;
    if (changes['isValid'] || changes['formatError'] || changes['validationError']) {
      this.refreshErrorDisplay();
    }
  }

  protected refreshErrorDisplay() {
    const error = this.model.formatError || this.model.validationError;
    if (!error) {
      this.originalDisplayStyle = this.element.style.display;
      this.element.style.display = 'none';
      this.element.innerText = '';
    } else {
      this.element.innerText = this.messageService.getMessage(error);
      if (this.originalDisplayStyle !== null) {
        this.element.style.display = this.originalDisplayStyle !== 'none' ? this.originalDisplayStyle : 'block';
        this.originalDisplayStyle = null;
      }
    }
  }

  protected refreshTags() {
    // PREVENT PARENT FROM SETTING TAGS OF VALUE ELEMENT
  }

  protected refreshTabIndex() {
    // PREVENT PARENT FROM SETTING TAB INDEX OF VALUE ELEMENT
  }

}
